module.exports = __webpack_public_path__ + "static/img/200080.8788e86f.png";